import { api } from './client';

/**
 * Self-serve account recovery. A web subscriber enters the email on their
 * subscription and we email a single-use magic link; clicking it on any device
 * restores their original account (access + progress).
 */

/** Ask for a recovery link. Always resolves — the server returns 200 regardless
 *  of whether the email has an account (no enumeration), so this never reveals
 *  account existence to the caller. */
export async function requestRecovery(email: string): Promise<void> {
  await api('/players/recovery/request', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

/** Exchange a magic-link token for the original player id to adopt. Throws
 *  (ApiError 400) if the token is unknown, already used, or expired. */
export async function claimRecovery(token: string): Promise<{ playerId: string; token: string | null }> {
  return api<{ playerId: string; token: string | null }>('/players/recovery/claim', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}
